import Vue from 'vue';
import Router from 'vue-router';
import { Role } from 'easyjs/lib/Role/Group';
import Home from './pages/Home.vue';
import CampaignForm from '@/pages/Performance/CampaignForm.vue';
import PerformanceErrorUsers from '@/pages/Performance/PerformanceErrorUsers.vue';
import AdsPerformance from '@/pages/Performance/AdsPerformance.vue';
import CampaignReport from '@/pages/Performance/CampaignReport.vue';
import CampaignDetails from '@/pages/Performance/CampaignDetails.vue';
import SuccessSignUp from '@/pages/Account/SuccessSignUp.vue';
import Login from './pages/Account/Login.vue';
import SignUp from './pages/Account/SignUp.vue';
import ForgotPassword from './pages/Account/ForgotPassword.vue';
import Sales from '@/pages/Sales.vue';
import OrdersWrapper from './pages/OrdersWrapper.vue';
import Cashdesk from '@/pages/Reports/Cashdesk.vue';
import Marketing from '@/pages/Marketing/Marketing.vue';
import MarketingChange from '@/pages/Marketing/Change.vue';
import MarketingResults from '@/pages/Marketing/Results.vue';
import Reports from '@/pages/Reports.vue';
import OrdersReport from '@/pages/Reports/Orders/OrdersReport.vue';
import CustomersReport from '@/pages/Reports/Customers/CustomersReport.vue';
import RatingReport from '@/pages/Reports/RatingReport.vue';
import Integrations from '@/pages/Integrations/Integrations.vue';
import GoogleAds from '@/pages/Integrations/GoogleAds/GoogleAds.vue';
import GoogleAdsRegister from '@/pages/Integrations/GoogleAds/GoogleAdsRegister.vue';
import GoogleAnalytics from '@/pages/Integrations/GoogleAnalytics/GoogleAnalytics.vue';
import GoogleAnalyticsRegister from '@/pages/Integrations/GoogleAnalytics/GoogleAnalyticsRegister.vue';
import GoogleTagManager from '@/pages/Integrations/GoogleTagManager/GoogleTagManager.vue';
import GoogleTagManagerRegister from '@/pages/Integrations/GoogleTagManager/GoogleTagManagerRegister.vue';
import FacebookPixel from '@/pages/Integrations/FacebookPixel/FacebookPixel.vue';
import FacebookPixelRegister from '@/pages/Integrations/FacebookPixel/FacebookPixelRegister.vue';
import JunoAbout from '@/pages/Integrations/Juno/JunoAbout.vue';
import JunoToken from '@/pages/Integrations/Juno/JunoToken.vue';
import FoodyDeliveryAbout from '@/pages/Integrations/FoodyDelivery/FoodyDeliveryAbout.vue';
import FoodyDeliveryRegister from '@/pages/Integrations/FoodyDelivery/FoodyDeliveryRegister.vue';
import Domains from '@/pages/Domains.vue';
import ProductsReport from '@/pages/Reports/ProductsReports.vue';
import History from './pages/History.vue';
import Customers from './pages/Customers.vue';
import Catalog from './pages/Catalog.vue';
import ImportCatalog from './pages/ImportCatalog.vue';
import Coupons from '@/pages/Coupons.vue';
import CouponResults from '@/pages/Coupon/CouponResults.vue';
import CouponsExpired from '@/pages/Coupon/CouponsExpired.vue';
import Configuration from './pages/Configuration.vue';
import Horary from './pages/Configuration/Horary.vue';
import HoraryNewLayout from './pages/Configuration/HoraryNewLayout.vue';
import Location from './pages/Configuration/Location.vue';
import Regions from './pages/Configuration/Regions.vue';
import Times from './pages/Configuration/Times.vue';
import Payment from './pages/Configuration/Payment.vue';
import Infos from './pages/Configuration/Infos.vue';
import Images from './pages/Configuration/Images.vue';
import Themes from './pages/Configuration/Themes.vue';
import Social from './pages/Configuration/Social.vue';
import Keys from './pages/Configuration/Keys.vue';
import Cashback from './pages/Configuration/Cashback.vue';
import Printers from './pages/Configuration/Printers/Printers.vue';
import Printer from './pages/Configuration/Printers/Printer.vue';
import Sms from './pages/Sms.vue';
import Push from './pages/Push.vue';
import Account from './pages/Account/Account.vue';
import Users from './pages/Account/Users.vue';
import Onboard from './pages/Onboard.vue';
import ModuleStore from './pages/ModuleStore.vue';
import InputForm from './containers/Inputs/TesteInputs.vue';

import store from './store/modules/account';

Vue.use(Router);

export default new Router({
  base: '/',
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'pedidos',
      component: OrdersWrapper,
      meta: { needsAuth: true },
    },
    {
      path: '/atendimento',
      name: 'atendimento',
      component: Sales,
      meta: { needsAuth: true },
    },
    {
      path: '/cashback',
      name: 'cashback',
      component: Cashback,
      meta: { needsAuth: true },
    },
    {
      path: '/easy-performance',
      name: 'easy-performance',
      component: CampaignReport,
      meta: { needsAuth: true },
    },
    {
      path: '/easy-performance/detalhes-campanha/:name',
      name: 'detalhes-campanha',
      component: CampaignDetails,
      meta: { needsAuth: true },
    },
    {
      path: '/easy-performance/criar-campanha',
      name: 'criar-campanha',
      component: CampaignForm,
      meta: { needsAuth: true },
    },
    {
      path: '/easy-performance/editar-campanha/:id',
      name: 'editar-campanha',
      component: CampaignForm,
      meta: { needsAuth: true },
    },
    {
      path: '/performance-error',
      name: 'performance-error',
      component: PerformanceErrorUsers,
      meta: { needsAuth: true },
    },
    {
      path: '/performance-ads',
      name: 'performance-ads',
      component: AdsPerformance,
      meta: { needsAuth: true },
    },
    {
      path: '/inputs',
      name: 'inputs',
      component: InputForm,
      meta: { needsAuth: true },
    },
    {
      path: '/pedidos',
      name: 'pedidos',
      component: OrdersWrapper,
      meta: { needsAuth: true },
    },
    {
      path: '/faturamento',
      name: 'faturamento',
      component: Cashdesk,
      meta: { needsAuth: true },
    },
    {
      path: '/marketing',
      name: 'marketing',
      component: Marketing,
      meta: { needsAuth: true },
    },
    {
      path: '/marketing/resultados',
      name: 'resultados',
      component: MarketingResults,
    },
    {
      path: '/marketing/criar',
      name: 'criar',
      component: MarketingChange,
    },
    {
      path: '/marketing/editar/:id',
      name: 'editar',
      component: MarketingChange,
    },
    {
      path: '/relatorios',
      name: 'relatorios',
      component: Reports,
      meta: { needsAuth: true },
    },
    {
      path: '/relatorio-pedidos',
      name: 'relatorio-pedidos',
      component: OrdersReport,
      meta: { needsAuth: true },
    },
    {
      path: '/relatorio-clientes',
      name: 'relatorio-clientes',
      component: CustomersReport,
      meta: { needsAuth: true },
    },
    {
      path: '/pesquisa-satisfacao',
      name: 'pesquisa-satisfacao',
      component: RatingReport,
      meta: { needsAuth: true },
    },
    {
      path: '/integracoes',
      name: 'integracoes',
      component: Integrations,
      meta: { needsAuth: true },
    },
    {
      path: '/google-ads',
      name: 'google-ads',
      component: GoogleAds,
      meta: { needsAuth: true },
    },
    {
      path: '/cadastro-google-ads',
      name: 'cadastro-google-ads',
      component: GoogleAdsRegister,
      meta: { needsAuth: true },
    },
    {
      path: '/google-analytics',
      name: 'google-analytics',
      component: GoogleAnalytics,
      meta: { needsAuth: true },
    },
    {
      path: '/cadastro-google-analytics',
      name: 'cadastro-google-analytics',
      component: GoogleAnalyticsRegister,
      meta: { needsAuth: true },
    },
    {
      path: '/google-tag-manager',
      name: 'google-tag-manager',
      component: GoogleTagManager,
      meta: { needsAuth: true },
    },
    {
      path: '/cadastro-google-tag-manager',
      name: 'cadastro-google-tag-manager',
      component: GoogleTagManagerRegister,
      meta: { needsAuth: true },
    },
    {
      path: '/facebook-pixel',
      name: 'facebook-pixel',
      component: FacebookPixel,
      meta: { needsAuth: true },
    },
    {
      path: '/cadastro-facebook-pixel',
      name: 'cadastro-facebook-pixel',
      component: FacebookPixelRegister,
      meta: { needsAuth: true },
    },
    /*
    {
      path: '/integracoes/sobre/:name',
      name: 'sobre-integracao',
      component: JunoAbout,
      meta: { needsAuth: true },
    },
    {
      path: '/integracoes/juno/token',
      name: 'juno-token',
      component: JunoToken,
      meta: { needsAuth: true },
    },
    */
    {
      path: '/integracoes/foody-delivery',
      name: 'foody-delivery-sobre',
      component: FoodyDeliveryAbout,
      meta: { needsAuth: true },
    },
    {
      path: '/integracoes/foody-delivery/cadastro',
      name: 'foody-delivery-cadastro',
      component: FoodyDeliveryRegister,
      meta: { needsAuth: true },
    },
    {
      path: '/dominios',
      name: 'dominios',
      component: Domains,
      meta: { needsAuth: true },
    },
    {
      path: '/produtos-cardapio',
      name: 'produtos-cardapio',
      component: ProductsReport,
      meta: { needsAuth: true },
    },
    {
      path: '/entrar',
      name: 'login',
      component: Login,
      meta: {
        bHasNoTemplate: true,
        needsAuth: false,
      },
    },
    {
      path: '/cadastro',
      name: 'signup',
      component: SignUp,
      meta: {
        bHasNoTemplate: true,
        needsAuth: false,
      },
    },
    {
      path: '/sucesso-cadastro',
      name: 'sucesso-cadastro',
      component: SuccessSignUp,
      meta: {
        bHasNoTemplate: true,
        needsAuth: false,
      },
    },
    {
      path: '/esqueci-minha-senha',
      name: 'forgotpassword',
      component: ForgotPassword,
      meta: {
        bHasNoTemplate: true,
        needsAuth: false,
      },
    },
    {
      path: '/sair',
      name: 'logout',
      component: {},
      meta: { needsAuth: true },
    },
    {
      path: '/historico',
      name: 'historico',
      component: History,
      meta: { needsAuth: true },
    },
    {
      path: '/clientes',
      name: 'clientes',
      component: Customers,
      meta: { needsAuth: true },
    },
    {
      path: '/cardapio',
      name: 'cardapio',
      component: Catalog,
      meta: { needsAuth: true },
    },
    {
      path: '/importador',
      name: 'importar-catalogo',
      component: ImportCatalog,
      meta: {
        bHasNoTemplate: true,
        needsAuth: false,
      },
    },
    {
      path: '/cupons',
      name: 'cupons',
      component: Coupons,
      meta: { needsAuth: true },
    },
    {
      path: '/cupons/expired',
      name: 'cupons-expirados',
      component: CouponsExpired,
      meta: { needsAuth: true },
    },
    {
      path: '/cupons/resultados/:code',
      name: 'resultados-cupom',
      component: CouponResults,
      meta: { needsAuth: true },
    },
    {
      path: '/configuracoes',
      name: 'configuracoes',
      component: Configuration,
      meta: { needsAuth: true },
    },
    {
      path: '/horario',
      name: 'horario',
      component: Horary,
      meta: { needsAuth: true },
    },
    {
      path: '/horario-novo-layout',
      name: 'horario-novo-layout',
      component: HoraryNewLayout,
      meta: { needsAuth: true },
    },
    {
      path: '/localizacao',
      name: 'localizacao',
      component: Location,
      meta: { needsAuth: true },
    },
    {
      path: '/regioes',
      name: 'regioes',
      component: Regions,
      meta: { needsAuth: true },
    },
    {
      path: '/tempos',
      name: 'tempos',
      component: Times,
      meta: { needsAuth: true },
    },
    {
      path: '/pagamento',
      name: 'pagamento',
      component: Payment,
      meta: { needsAuth: true },
    },
    {
      path: '/informacoes',
      name: 'informacoes',
      component: Infos,
      meta: { needsAuth: true },
    },
    {
      path: '/imagens',
      name: 'imagens',
      component: Images,
      meta: { needsAuth: true },
    },
    {
      path: '/temas',
      name: 'temas',
      component: Themes,
      meta: { needsAuth: true },
    },
    {
      path: '/social',
      name: 'social',
      component: Social,
      meta: { needsAuth: true },
    },
    // {
    //   path: '/chaves',
    //   name: 'chaves',
    //   component: Keys,
    //   meta: { needsAuth: true }
    // },
    {
      path: '/impressoras',
      name: 'impressoras',
      component: Printers,
      meta: { needsAuth: true },
    },
    {
      path: '/impressora',
      name: 'impressora',
      component: Printer,
      meta: { needsAuth: true },
    },
    {
      path: '/sms',
      name: 'sms',
      component: Sms,
      meta: { needsAuth: true },
    },
    {
      path: '/push',
      name: 'push',
      component: Push,
      meta: { needsAuth: true },
    },
    {
      path: '/minha-conta',
      name: 'minha-conta',
      component: Account,
      meta: { needsAuth: true },
    },
    {
      beforeEnter(to, from, next) {
        const { group } = store.state.oUser;

        if (![Role.ADMIN, Role.MASTER].includes(group)) {
          next('/atendimento');
        }

        next();
      },
      path: '/usuarios',
      name: 'usuarios',
      component: Users,
      meta: { needsAuth: true },
    },
    {
      path: '/onboard',
      name: 'onboard',
      component: Onboard,
      meta: { needsAuth: true },
    },
    {
      path: '/loja-de-modulos',
      name: 'loja-de-modulos',
      component: ModuleStore,
      meta: { needsAuth: true },
    },
    { path: '*', redirect: '/' },
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});

// lidando com roteamento redundante
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((error) => {
    throw new Error(error);
  });
};
